export default __webpack_public_path__ + "static/media/rarity-2.bf396401.png";